import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=5c83a8bf&scoped=true&"
import script from "./AddEvent.vue?vue&type=script&lang=js&"
export * from "./AddEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83a8bf",
  null
  
)

export default component.exports